import { Box } from '@nimbus-ds/components';
import { useTranslation } from 'react-i18next';
import { CurrencyType, RefundAttemptDto } from '@tiendanube/common';
import AmountDto from '@tiendanube/common/dist/src/domains/payments/refund/AmountDto';
import { Domain } from '@tiendanube/common/src/enums';
import { DataList, Text } from '@tiendanube/components';
import { CurrencyPrice } from 'commons/components';

interface Attributes {
  isTotalUpdated: boolean;
  total: number;
  currency: CurrencyType;
  refundAttempts: RefundAttemptDto[];
  merchantChargesTotalAmount?: AmountDto;
  refundedMerchantChargesTotalAmount?: AmountDto;
}

function OrderTotalAmountRow({
  isTotalUpdated,
  total,
  refundAttempts,
  currency,
  merchantChargesTotalAmount,
  refundedMerchantChargesTotalAmount,
}: Attributes): JSX.Element {
  const { t } = useTranslation(Domain.ORDERS, {
    keyPrefix: 'orderSummaryCard.tableAmounts',
  });
  const refundedAmount = () =>
    refundAttempts
      .filter((a) => a.status.code === 'success')
      .reduce((sum, attempt) => sum + Number(attempt.refunded_amount.value), 0);

  const getTotal = () => {
    if (isTotalUpdated) {
      return total;
    }

    return (
      total -
      Number(merchantChargesTotalAmount?.value ?? '0.00') -
      refundedAmount() +
      Number(refundedMerchantChargesTotalAmount?.value ?? '0.00')
    );
  };

  return (
    <DataList.Row id="total" grayed>
      <DataList.Cell width={70}>
        <Box display="flex" flexDirection="row" gap="0-5">
          <Text bold>{isTotalUpdated ? t('updatedTotal') : t('total')}</Text>
        </Box>
      </DataList.Cell>
      <DataList.Cell width={30}>
        <CurrencyPrice
          price={getTotal()}
          currency={currency}
          block
          textAlign="right"
          bold
        />
      </DataList.Cell>
    </DataList.Row>
  );
}
export default OrderTotalAmountRow;
